/**
 * Short description
 *
 * (c) tiglog <xq@tiglog.com>
 *
 * For the full copyright and license information, please view the LICENSE file
 * that was distributed with this source code.
 */

(function(window, undefined) {

    var util = {};
    util.xhrOnProgress = function(fun) {
        return function() {
            var xhr = $.ajaxSettings.xhr();
            if (typeof fun !== 'function')
                return xhr;
            if (fun && xhr.upload) {
                xhr.upload.onprogress = fun;
            }
            return xhr;
        }
    };
    util.showMsg = function (msg) {
        if (!msg) {
            return;
        }
        layer.msg(msg);
    };


    /**
     * 支持文件，不过有文件上传时，需要设置 contentType 和 processData 均为 false
     */
    var getFormData = function($form) {
        if ( (typeof $form === 'undefined') || !$form.length ) {
            return {};
        }
        return new FormData($form[0]);
    };

    var okHandle = function (elt, res) {
        if ( typeof elt.data('reload') !== 'undefined' ) {
            util.showMsg(res.msg);
            setTimeout(function() {
                window.location.reload();
            }, 1000);
            return;
        }
        util.showMsg(res.msg);
        if ( elt.data('remove')) {
            $(elt.data('remove')).remove();
            return;
        }
        if ( elt.data('replace')) {
            $(elt.data('replace')).empty().html(res.data);
            return;
        }
        if ( elt.data('append')) {
            $(elt.data('append')).append(res.data);
            return;
        }
        if ( elt.data('prepend')) {
            $(elt.data('prepend')).prepend(res.data);
            return;
        }
    }

    // <a href="url" data-toggle="xmodal" data-type="form">click</a>
    var modal = {
        init: function () {
            $(document).on('click', 'a[data-toggle="xmodal"]', function(e) {
                e.preventDefault();
                var self = $(this), _type = self.data('type'); // form, info, preview, post, delete

                // 如果是 iframe，则直接通过 iframe 显示 url 内容
                if ( _type == 'iframe' ) {
                    if ( self.attr('href') == 'javascript:;' ) {
                        layer.msg(self.data('msg') || '页面不存在');
                        return true;
                    }
                    layer.open({
                        title: false,
                        type: 2,
                        content: self.attr('href'),
                        area: self.data('area') ? self.data('area').split(',') : 'auto'
                    });
                    return true;
                }

                // 执行 post 请求
                var doPost = function (url, postData, hasFile, cb) {
                    var submitLayerId = layer.msg('<span>提交中...</span>', {icon: 16,shade: 0.1, time: 0});
                    var options = {
                        type: 'post',
                        url: url,
                        dataType: 'json',
                        data: postData,
                        processData: false,
                        contentType: false
                    };
                    //console.log('has file ' + hasFile);
                    if ( hasFile ) {
                        var submitlayero = $('#layui-layer' + submitLayerId).find('.layui-layer-content > span');
                        options.xhr = util.xhrOnProgress( function(ev) {
                            var percent=ev.loaded / ev.total;
                            //console.log('upload percent ' + submitLayerId + ', '  + percent);
                            submitlayero.html('提交中 ' + (100 * percent).toFixed(2) + '% ...');
                        });
                    }
                    $.ajax(options)
                    .done( function(res) {
                        // console.log(res);
                        if (res.stat != 'ok') {
                            util.showMsg(res.msg || 'fail');
                            return;
                        }
                        okHandle(self, res);
                        if($.isFunction(cb)) {
                            cb();
                        }
                    })
                    .fail( function (res) {
                        // console.log('fail', res);
                        util.showMsg(res.responseText);
                    })
                    .always( function () {
                        layer.close(submitLayerId);
                    });
                }

                // 如果是 post，则直接执行 post请求.如果是 delete，则一般需要确认一下
                if (_type == 'post' || _type == 'delete') {
                    var _confirmTxt = self.data('confirm') || self.data('confirmx');
                    var handlePost = function () {
                        var data = new FormData();
                        data.append('ts', (new Date()).getTime() / 1000);
                        var _csrfn = $('meta[name="csrf-param"]').attr('content') || 'csrf',
                            _csrfv = $('meta[name="csrf-token"]').attr('content');
                        if ( _csrfv ) { data.append(_csrfn, _csrfv); }
                        doPost(self.attr('href'), data, false);
                        return true;
                    }
                    if (_confirmTxt) {
                        layer.confirm(_confirmTxt, {icon: 3, title:'提示'}, handlePost);
                        return true;
                    }
                    return handlePost();
                };

                // 带 form 点击确定的回调函数
                var onYes = function(index, layero) {
                    var $form = layero.find('form');
                    if ( !$form.length )  {
                        return true;
                    }
                    doPost(self.attr('href'), getFormData($form), $form.find('input[type="file"]').length > 0, function () {
                        layer.close(index);
                    });
                    return true;
                };


                // 其他 type 都到这儿来
                var loadingId = layer.load();
                $.get(this.href)
                .done( function(res) {
                    var options = { content: '<div style="padding:15px 15px 0;">' + res + '</div>', type: 1};
                    if ( self.data('area') ) {
                        options.area = self.data('area').split(',');
                    }
                    if ( self.attr('title') ) { options.title = self.attr('title'); }
                    if ( _type == 'preview' ) {
                        options.type = 1; options.title = false;
                    } else if ( _type == 'form' ) {
                        options.title = self.attr('title') || self.html();
                        options.btn = self.data('btn') ? self.data('btn').split(',') : ['保存', '关闭'];
                        options.yes = onYes;
                    }
                    layer.open(options);
                })
                .fail(function (res) {
                    util.showMsg(res.responseText);
                })
                .always( function() {
                    layer.close(loadingId);
                });

                return false;
            });
        }
    };


    window.tiglog = {
        util: util,
        modal: modal
    };
    modal.init();

})(window);
